import React,{memo} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CheckIcon from '@mui/icons-material/Check';
import FilterListIcon from '@mui/icons-material/FilterList';
import { UiToggleButton } from "./UiButton";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const UiAccordian = memo((props) => {
    const {  icon , onClick, name,children} = props;
    return (
        <>
            <div className="sbt-toggle-area-wr">
                <Accordion  className='sbt-filter-accordian'>                    
                    <UiToggleButton>
                        <AccordionSummary
                            expandIcon={<KeyboardArrowDownIcon/>}
                            aria-controls="panel1-content">
                            <FilterListIcon />&nbsp;filter
                        </AccordionSummary>
                    </UiToggleButton>
                        
                        <AccordionDetails>
                            {children}
                        </AccordionDetails>
                </Accordion> 
            </div>           
        </>
    )

})
export const UiInternalAccordian = memo((props) => {
    const {  icon , onClick, name,children} = props;
    return (
        <>
            <div className="sbt-toggle-area-wr">
                <Accordion  className='sbt-filter-accordian'>                    
                    {/* <UiToggleButton> */}
                        <AccordionSummary
                            expandIcon={<KeyboardArrowDownIcon/>}
                            aria-controls="panel1-content">
                            <FilterListIcon />&nbsp;filter
                        </AccordionSummary>
                    {/* </UiToggleButton> */}
                        
                        <AccordionDetails>
                            {children}
                        </AccordionDetails>
                </Accordion> 
            </div>           
        </>
    )

})